import { render } from "./Profilo.vue?vue&type=template&id=20ff326e&scoped=true&ts=true"
import script from "./Profilo.vue?vue&type=script&lang=ts"
export * from "./Profilo.vue?vue&type=script&lang=ts"

import "./Profilo.vue?vue&type=style&index=0&id=20ff326e&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_gm-system_1770887991853013682/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ff326e"]])

export default __exports__